import React, { useRef, useState, useEffect } from "react";
import styles from "./student-gallery.module.scss";
import { gsap } from "gsap";
import SbEditable from "storyblok-react";
import StudentGalleryItem from "~components/custom/students-gallery/student-gallery-item";
import { getHref } from "~helpers/generic-helpers";
import useCurrentWidth from "./utils/useWidth";

const StudentGalleryRow = (props: any) => {
  const editorKey: string = "editor";
  const { student_profiles, direction, duration } = props;

  const width = useCurrentWidth();
  const [tl] = useState(gsap.timeline({ paused: true, repeat: -1 }));
  const doubledItems = [...student_profiles, ...student_profiles];
  const wrapperRef = useRef(null);
  const cardRefs = useRef([]);
  let currentHref = getHref();
  let isEditor = currentHref.includes(editorKey);

  const handleStop = (event: any = null, force: boolean = false) => {
    if (!isEditor) {
      tl && tl.pause();
    } else if (force) {
      tl && tl.pause();
    } else if (tl && tl.vars.paused && event) {
      tl.pause();
    }
  };

  const handlePlay = (event: any = null, force: boolean = false) => {
    if (!isEditor) {
      tl && tl.play();
    } else if (force) {
      tl && tl.play();
    } else if (tl && !tl.vars.paused && event) {
      tl.play();
    }
  };

  // @ts-ignore
  const addToRefs = (el) => {
    // @ts-ignore
    if (cardRefs.current && el !== null && !cardRefs.current.includes(el)) {
      // @ts-ignore
      cardRefs.current.push(el);
    }
  };

  useEffect(() => {
    const boxWidth = width > 720 ? 287 : 160;
    const boxHeight = width > 720 ? 370 : 210;
    const responsiveMargin = width > 720 ? 24 : 14;

    const wrapWidth = cardRefs.current.length * (boxWidth + responsiveMargin);
    const viewWrap = gsap.utils.wrap(0, wrapWidth);

    // Get current href and update it on mount
    currentHref = getHref();
    isEditor = currentHref.includes(editorKey);

    gsap.set(wrapperRef.current, {
      x: -boxWidth,
    });

    cardRefs.current.forEach((card, i) => {
      gsap.set(card, {
        x: i * boxWidth + i * responsiveMargin,
        width: boxWidth,
        height: boxHeight,
      });
    });

    tl.to(cardRefs.current, {
      x: `${direction === "1" ? "+" : "-"}=${wrapWidth}`,
      duration: Number(duration) ?? 125,
      ease: "none",
      modifiers: {
        x: (x) => viewWrap(parseFloat(x)) + "px",
      },
    });
  }, [width]);

  useEffect(() => {
    handlePlay();
    return () => {
      if (!isEditor) {
        tl.kill();
      }
    };
  }, [cardRefs.current]);

  return doubledItems.length ? (
    <SbEditable content={props}>
      <div className={styles.inner} ref={wrapperRef}>
        {doubledItems.map((item, index) => (
          <StudentGalleryItem
            onMouseEnter={(event: any) => handleStop(event)}
            onMouseLeave={(event: any) => handlePlay(event)}
            key={`${item._uid}${index}`}
            image={item.image}
            title={item.title}
            ref={addToRefs}
            handlePlay={() => handlePlay()}
            handleStop={() => handleStop()}
            {...item}
          />
        ))}
      </div>
    </SbEditable>
  ) : null;
};

export default StudentGalleryRow;
